/**
 * The default formatter for the week number.
 */
export function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
//# sourceMappingURL=formatWeekNumber.js.map